import React, { useContext } from "react";
import { CompositeStateReturn } from "reakit/Composite";

export interface TimeReportCalendarGridContextValue {
  compositeState: CompositeStateReturn;
  isEditable: boolean;
}

export const TimeReportCalendarGridContext = React.createContext<TimeReportCalendarGridContextValue>({
  compositeState: {} as any,
  isEditable: false,
});

export const useTimeReportCalendarGrid = () => useContext(TimeReportCalendarGridContext);
